module.exports = __webpack_public_path__ + "static/media/logo.43192e43.svg";